import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { Category } from "../../../Domain/Model/Category";
import CategoryDataSource from "../CategoryDataSource";
import { CategoryAPIEntity } from "./Entity/CategoryAPIEntity";

// const baseURL = `${Environment.apiUrl}/category`;
const routeName = `/v1/category`;
 
export default class CategoryAPIDataSourceImpl implements CategoryDataSource {
  
  
  async createCategory(data: Category): Promise<CategoryAPIEntity[]> {
    try {
        // Define los datos que deseas enviar en la petición POST
        const postData = {
          name: data.name,
          icon: data.icon,
        };
    
        // Realiza la petición POST utilizando api
        const response = await api.post<ApiResponse<any>>(routeName, postData);
        
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Mapea los datos de la respuesta al formato de CategoryAPIEntity que esperas
          const categories = response.data.data;
          
          return categories;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al agragar la categoría:", error);
        throw new Error("Error al agragar la categoría");
      }
    }
    
    
    async getCategories(): Promise<CategoryAPIEntity[]> {
      try {
        const response = await api.get<ApiResponse<any>>(routeName);
        // console.log(response.data.data);
        const listCategories = response.data.data;
        // Verifica si la respuesta contiene datos
        if (listCategories && Array.isArray(listCategories)) {
          // Mapea los datos de la respuesta al formato de Category que esperas
          const categories: Category[] = listCategories.map((item: Category) => ({
            id: item.id,  
            name: item.name, 
            icon: item.icon
          }));
          
          return categories;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener las categorías:", error);
        throw new Error("Error al obtener las categorías");
      }
    }

    async updateCategory(data: Category): Promise<boolean> {
      try {
        // Realiza la petición PUT utilizando api
        const response = await api.put(`${routeName}`, data);
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la actualización fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al actualizar la categoría:", error);
        throw new Error("Error al actualizar la categoría");
      }
    }

    async removeCategory(id: string): Promise<boolean> {
      try {
        // Realiza la petición DELETE utilizando api
        const response = await api.delete(`${routeName}/${id}`);
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la eliminación fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al eliminar la categoría:", error);
        throw new Error("Error al eliminar la categoría");
      }
    }
   
  }